/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Acwr_One_LinerInputs */

const en_exp_acwr_one_liner = /** @type {(inputs: Exp_Acwr_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compares your training load of the last 7 days to the last 42 days, both smoothed — tells you if you are ramping up safely.`)
};

const de_exp_acwr_one_liner = /** @type {(inputs: Exp_Acwr_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleicht deine Belastung der letzten 7 Tage mit den letzten 42 Tagen, beide geglättet — zeigt, ob du sicher steigerst.`)
};

/**
* | output |
* | --- |
* | "Compares your training load of the last 7 days to the last 42 days, both smoothed — tells you if you are ramping up safely." |
*
* @param {Exp_Acwr_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_acwr_one_liner = /** @type {((inputs?: Exp_Acwr_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Acwr_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_acwr_one_liner(inputs)
	return de_exp_acwr_one_liner(inputs)
});